import { Dispatch } from '../../../../../types/actions';
import { getMessages } from '../../../../../store/constants';
import { snackbarSuccessDefault } from '../variantSuccess/successDefault';
import { SNACKBAR_ID_ARCHIVE } from '../constants';

export const snackbarListArchived = () => {
    return (dispatch: Dispatch) => {
        dispatch(snackbarSuccessDefault({
            id: SNACKBAR_ID_ARCHIVE,
            icon: 'archive',
            text: getMessages().getText('snackbar.archive.list.text')
        }));
    }
};
